import React, { type ReactNode } from "react";

export function DefaultErrorAndLoadingStatusWrapper(
  components: ReactNode,
): ReactNode {
  return components;
}

export function EmptyStatusWrapper(components: ReactNode): ReactNode {
  return <></>;
}
